import { PersistedWidgetSpec } from 'shared/types/widgets'

export const normalizeDisplayOrder = (
  items: PersistedWidgetSpec[]
): PersistedWidgetSpec[] =>
  items.map((item, idx) => ({ ...item, displayOrder: idx + 1 }))
